import React, { Component } from 'react';
import {
  withStyles,
  Box,
  Typography,
  List,
  ListItem,
  Checkbox,
  Tooltip,
} from '@material-ui/core';
import Loader from '../../../shared/Loaders/Loader';

const styles = () => ({
  permissionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  header: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '175%',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px 24px',
  },
  permission: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  listHeader: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '157%',
    textTransform: 'Capitalize',
  },
  listItemText: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '180%',
  },
  list: {
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
  },
  listItem: {
    padding: '0px',
  },
  checkbox: {
    padding: '0px',
    height: '42px',
    width: '42px',
    '&$checked': {
      color: '#452188',
    },
  },
  checked: {},
});

class Permissions extends Component<any> {
  state = {
    loading: true,
  };
  componentWillMount = async () => {
    this.props.fetchPermissions();
  };

  componentDidMount = async () => {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 5000);
  };
  handleSelectedValueCheck(permissionKey) {
    if (this.props?.selectedValues?.indexOf(permissionKey) !== -1) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const {
      classes,
      permissions,
      handleChange,
      readOnly,
      selectedValues,
      disabledPermissions,
      fallbackRole = 'educator',
    } = this.props;
    if (this.state.loading) {
      return <Loader />;
    }

    // Debug logging
    if (selectedValues && selectedValues.length > 0) {
      console.log('Selected permission keys:', selectedValues);
      console.log('Available permissions:', permissions);
    }

    return (
      <Box className={classes.permissionsContainer}>
        <Typography className={classes.header}>
          {readOnly ? 'Permissions' : 'Manage Permissions'}
        </Typography>
        <Box className={classes.grid}>
          {Object.keys(permissions)?.map((permission, index) => (
            <Box className={classes.permission} key={`${permission}-${index}`}>
              <Typography className={classes.listHeader}>
                {permission}
              </Typography>
              <List className={classes.list}>
                {permissions[permission].map((el) => {
                  // Use key if available, otherwise fallback to id for backward compatibility
                  const permissionKey = el.key || el.id;
                  const isPermissionDisabled =
                    disabledPermissions &&
                    disabledPermissions.includes(permissionKey);
                  const isEffectiveDisabled = readOnly || isPermissionDisabled;

                  return (
                    <ListItem className={classes.listItem} key={permissionKey}>
                      <Checkbox
                        onChange={
                          readOnly
                            ? undefined
                            : () => handleChange(permissionKey)
                        }
                        classes={{ checked: classes.checked }}
                        className={classes.checkbox}
                        checked={this.handleSelectedValueCheck(permissionKey)}
                        disabled={isEffectiveDisabled}
                      />
                      <Tooltip
                        title={
                          isPermissionDisabled
                            ? `This permission is not available for ${fallbackRole}`
                            : el.description || 'no description'
                        }
                        placement="right"
                        arrow
                        disableFocusListener
                        disableTouchListener
                      >
                        <Typography
                          className={classes.listItemText}
                          style={
                            isPermissionDisabled ? { opacity: 0.5 } : undefined
                          }
                        >
                          {el.label}
                        </Typography>
                      </Tooltip>
                    </ListItem>
                  );
                })}
              </List>
            </Box>
          ))}
        </Box>
      </Box>
    );
  }
}

export default withStyles(styles as any, { withTheme: true })(Permissions);
